if (!customElements.get("footer-details")) {
  class FooterDetails extends AccordionDetails {
    constructor() {
      super();
    }

    connectedCallback() {
      // De footerblokken staan op elk schermformaat open en zijn niet in te klappen.
      // Voorheen klapte dit onder 1024px dicht (behalve met data-open-default="true") en
      // stond er een +/- icoon naast de kop; dat icoon is uit sections/footer.liquid
      // gehaald. De setting "standaard open" in de theme editor doet hierdoor niets meer
      // voor de footer.
      this.open = true;
    }

    // AccordionDetails hangt zelf een click-listener op de <summary> die dit aanroept.
    // Door hier alleen preventDefault te doen klapt er niets meer in of uit, ook niet
    // met Enter op het toetsenbord (dat vuurt eveneens een click op de summary).
    toggleAccordion(event) {
      event.preventDefault();
    }
  }
  customElements.define('footer-details', FooterDetails, { extends: 'details' });
}
